import React, {useState, useEffect, useMemo, Fragment} from "react"
import {useDispatch, useSelector} from "react-redux"
import {Transition} from "react-transition-group"

import LeftWorkHeader from "../LeftWorkHeader/LeftWorkHeader"
import Input from "../LeftWorkText/Input"
import ColorBtn from "../LeftWorkColor/ColorBtn"

import {setLeftWorkAreaState} from "../../../redux/actions/product2dActions"

import "./leftworkoutline.scss"

import {colors} from "../../../constants/utils"

/**
 * Component for add/edit text outline
 * @component
 * @param  {object} props
 * @param  {boolean} props.active - window state
 *
 * @example
 * const active = false
 *
 * return (
 *  <LeftWorkOutline
 *    active={active}
 *  />
 * )
 */

//  /**
//  * Select font
//  * @param {object} e - element
//  * @param {object} e.target - target element
//  */

const LeftWorkOutline = ({active}) => {
  const [outline, setOutline] = useState({
    weight: 0,
    color: null,
  })
  const dispatch = useDispatch()
  const makFabric = useSelector(state => state.makFabric)

  /**
   * back to editing
   */
  const backToEdit = () => {
    dispatch(setLeftWorkAreaState("EDIT_TEXT"))
  }

  /**
   * Change outline weight with buttons
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleWeight = e => {
    e.preventDefault()
    e.target.name === "plus" &&
      setOutline(prev => ({...prev, weight: parseInt(prev.weight) + 1}))
    e.target.name === "minus" &&
      setOutline(prev => ({...prev, weight: parseInt(prev.weight) - 1}))
  }
  /**
   * Change outline weight
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const changeWeight = ({target}) => {
    setOutline(prev => ({
      ...prev,
      [target.name]: target.value.replace(/[^+\d]/g, ""),
    }))
  }

  /**
   * Select outline color
   * @param {object} e - element
   * @param {object} e.target - target element
   */
  const handleSelectColor = ({target}) => {
    setOutline(prev => ({...prev, color: target.dataset.color}))
  }

  useEffect(() => {
    if (makFabric && outline.weight && outline.color) {
      makFabric.setFontOutline(makFabric.getSelectedText(), outline)
    }
  }, [makFabric, outline.weight, outline.color, outline])

  const renderColors = useMemo(
    () =>
      colors.map(item => (
        <ColorBtn
          key={item.color}
          color={item.color}
          title={item.label}
          active={outline.color === item.color}
          handler={handleSelectColor}
        />
      )),
    [outline.color],
  )

  return (
    <Transition
      in={active}
      timeout={200}
      unmountOnExit={true}
      mountOnEnter={true}
    >
      {state => (
        <div
          className="leftWorkOutlineContainer"
          style={{
            ...transitionStyles[state],
          }}
        >
          <LeftWorkHeader
            title="Text Outline"
            handler={backToEdit}
            activeHandler={true}
          />
          <div className="leftWorkOutlineContent">
            <div className="leftWorkOutlineTopBox">
              <span>Weight</span>
              <div className="leftWorkOutlineInptCont">
                <Input
                  name="weight"
                  value={outline.weight}
                  handler={handleWeight}
                  changes={changeWeight}
                />
              </div>
            </div>

            <div className="leftWorkOutlineColorTitle">
              <span>Outline color</span>
              {!outline.color ? (
                <Fragment>
                  <div className="leftWorkOutlineTitle_color"></div>
                  <span>None</span>
                </Fragment>
              ) : (
                <div
                  className="leftWorkOutlineTitle_color"
                  style={{backgroundColor: outline.color}}
                ></div>
              )}
            </div>

            <div className="leftWorkOutlineColorsContainer">{renderColors}</div>
          </div>
        </div>
      )}
    </Transition>
  )
}

export default LeftWorkOutline

const transitionStyles = {
  entering: {opacity: 0},
  entered: {opacity: 1, position: "relative"},
  exiting: {opacity: 0},
  exited: {opacity: 0},
}
